module.exports = __webpack_public_path__ + "static/media/mental-blue.8a6dea31.svg";